import React, { Component } from 'react'
import noDataImg from 'Assets/images/zonesetting/nothavemetadata.png'

export default function NotHaveMetaData(props) {
	return (
		<div className='not-have-meta-data'>
			<img src={noDataImg} alt=""/>
			{props.text}
		</div>
	)
}
